import * as l from '../../lib/littlejs.esm.js';
import { vec2 } from '../../lib/littlejs.esm.js';
import Rex from '../entities/rex.ts';
import Chip from '../entities/chip.ts';
import SmallPlatform from '../entities/smallPlatform.ts';
import Platform from '../entities/platform.ts';
import Camera from '../camera.ts';
import HUD from '../hud.ts';
import Globals from "../globals.ts";
import Door from '../entities/actionables/door.ts';
import RemoteDoor from '../entities/actionables/remoteDoor.ts';
import Lever from '../entities/actionables/lever.ts';
import PressurePlate from '../entities/actionables/pressurePlate.ts';
import Key from '../entities/actionables/key.ts';
import LockedDoor from '../entities/actionables/lockedDoor.ts';
import Trap from '../entities/traps/trap.ts';
import ElectricityBarrier from '../entities/traps/electricityBarrier.ts';
import ShootingEnemy from '../entities/enemies/shootingEnemy.ts';
import Checkpoint from '../entities/checkpoint.ts';
import Goal from '../entities/goal.ts';
import { tilesize, tilesheets } from '../const/tiles.ts';
const tilesetWidth = 192;
const tilesetHeight = 128;
let camera = new Camera();
let hud = new HUD();
// Player
let rex = null;
let chip = null;
let player = "rex";
// Player
let playerObject;
// Platforms and other scene objects
let platforms = [];
let smallPlatforms = [];
// Respawn players at last checkpoint
function respawn() {
    if (!rex || !chip)
        return;
    rex.pos = Globals.lastCheckpoint.copy();
    chip.pos = Globals.lastCheckpoint.copy();
    rex.health = 5;
    chip.health = 1;
    chip.battery = 100;
    rex.invincibleTimer = 0;
    rex.velocity = vec2(0, 0);
    rex.jumpCount = 0;
    rex.jumpPressed = false;
    chip.velocity = vec2(0, 0);
    rex.chipOnBack = false;
    chip.visible = true;
    if (player == "chip") {
        switchPlayer();
    }
}
// Game init
function init(rexLevel, chipLevel) {
    console.log('Game init', rexLevel);
    // Reset timer and completion status (timer will be started after levelStart countdown)
    Globals.levelCompletionTime = 0;
    Globals.levelCompleted = false;
    // Clear entitiesData at the start of each level load to avoid duplicates
    Globals.entitiesData = [];
    // Clear all existing objects to prevent accumulation between levels
    for (let i = l.engineObjects.length - 1; i >= 0; i--) {
        l.engineObjects[i].destroy();
    }
    // Recreate camera and hud after clearing
    camera = new Camera();
    hud = new HUD();
    // Reset arrays
    platforms = [];
    smallPlatforms = [];
    // Reset keys inventory
    Globals.keys = 0;
    Globals.rexHasKey = false;
    // Set gravity for platformer
    l.setGravity(vec2(0, -.02));
    // Calculate map dimensions from level data or use defaults
    const mapWidth = rexLevel ? rexLevel.pxWid / tilesize : 40;
    const mapHeight = rexLevel ? rexLevel.pxHei / tilesize : 16;
    let collisionLayer = new l.TileCollisionLayer(vec2(0, 0), vec2(mapWidth, mapHeight));
    // Background layer
    const backgroundLayer = new l.TileLayer(vec2(0, 0), vec2(mapWidth, mapHeight));
    // for(let x = 0; x < mapWidth; x++) {
    //   for (let y = 0; y < mapHeight; y++) {
    //     const tileIndex = 0;
    //     const direction = 0;
    //     const mirror = false;
    //     const color = new l.Color(1, 1, 1, 1);
    //     const data = new l.TileLayerData(tileIndex, direction, mirror, color);
    //     backgroundLayer.setData(vec2(x,y), data);
    //     // collisionLayer.setCollisionData(vec2(x,y), 1);
    //   }
    // }
    console.log(backgroundLayer);
    backgroundLayer.redraw();
    // create tile collision and visible tile layer
    const pos = vec2();
    const tileLayer = new l.TileLayer(pos, vec2(mapWidth, mapHeight), new l.TileInfo(vec2(0), vec2(32)));
    // Adding walls all around the map
    if (!rexLevel) {
        // Only add hardcoded walls if no level data provided
        for (let x = 0; x < mapWidth; x++) {
            for (let y = 0; y < mapHeight; y++) {
                if (x == 0 || x == (mapWidth - 1) || y == 0) {
                    const tileIndex = 1;
                    const direction = 0;
                    const mirror = false;
                    const color = new l.Color(1, 1, 1, 1);
                    const data = new l.TileLayerData(tileIndex, direction, mirror, color);
                    const pos = vec2(x, y);
                    tileLayer.setData(pos, data);
                    collisionLayer.setCollisionData(pos, 1);
                }
            }
        }
    }
    // Load tiles from LDtk - now loading all layers
    const layers = rexLevel ? rexLevel.layerInstances : null;
    // Find background layer (should be the second layer)
    const backgroundLayerInstance = layers.find((layer) => layer.__identifier === 'Background');
    const tilesLayerInstance = layers.find((layer) => layer.__identifier === 'Tiles');
    // Parse Entities layer for Rex level
    const entitiesLayerInstance = layers.find((layer) => layer.__identifier === 'Entities');
    if (entitiesLayerInstance) {
        for (const entity of entitiesLayerInstance.entityInstances) {
            const fullIdentifier = entity.__identifier;
            // Extract className and id from identifier (e.g., "RemoteDoor_1" -> className: "RemoteDoor", id: "1")
            const parts = fullIdentifier.split('_');
            let className = parts[0];
            let id = parts.length > 1 ? parts[1] : null;
            // For RemoteDoor, Lever, PressurePlate, use the "actionable" field value as id if present
            if (entity.fieldInstances) {
                const actionableField = entity.fieldInstances.find((field) => field.__identifier === 'actionable');
                if (actionableField && actionableField.__value !== null) {
                    id = actionableField.__value.toString();
                }
            }
            let position;
            if (entity.px) {
                // Use pixel coordinates
                const x = entity.px[0] / tilesize;
                const y = mapHeight - 1 - (entity.px[1] / tilesize); // Invert Y axis
                position = vec2(x, y);
            }
            else if (entity.__grid) {
                // Use grid coordinates
                const x = entity.__grid[0];
                const y = mapHeight - 1 - entity.__grid[1]; // Invert Y axis
                position = vec2(x, y);
            }
            else {
                // Fallback to origin if no position data
                position = vec2(0, 0);
            }
            Globals.entitiesData.push({ className, id, position });
        }
    }
    // Parse Entities layer for Chip level if exists
    if (chipLevel) {
        const chipLayers = chipLevel.layerInstances;
        const chipEntitiesLayerInstance = chipLayers.find((layer) => layer.__identifier === 'Entities');
        if (chipEntitiesLayerInstance) {
            for (const entity of chipEntitiesLayerInstance.entityInstances) {
                const fullIdentifier = entity.__identifier;
                // Extract className and id from identifier (e.g., "RemoteDoor_1" -> className: "RemoteDoor", id: "1")
                const parts = fullIdentifier.split('_');
                let className = parts[0];
                let id = parts.length > 1 ? parts[1] : null;
                // For RemoteDoor, Lever, PressurePlate, use the "actionable" field value as id if present
                if (entity.fieldInstances) {
                    const actionableField = entity.fieldInstances.find((field) => field.__identifier === 'actionable');
                    if (actionableField && actionableField.__value !== null) {
                        id = actionableField.__value.toString();
                    }
                }
                let position;
                // Loading the origin_x and origin_y from the level fields
                let originX = 0;
                let originY = 0;
                if (chipLevel.fieldInstances?.length) {
                    chipLevel.fieldInstances.forEach((levelField) => {
                        if (levelField.__identifier == "origin_x") {
                            originX = levelField.__value;
                        }
                        if (levelField.__identifier == "origin_y") {
                            originY = levelField.__value;
                        }
                    });
                }
                if (entity.px) {
                    // Use pixel coordinates, scale by dividing by 4 and offset by origin_x and origin_y
                    const x = originX + (entity.px[0] / tilesize) / 4;
                    const y = originY - (entity.px[1] / tilesize) / 4;
                    position = vec2(x, y);
                }
                else if (entity.__grid) {
                    // Use grid coordinates, scale by dividing by 4 and offset by origin_x and origin_y
                    const x = (entity.__grid[0] / 4) + originX;
                    const y = mapHeight - ((entity.__grid[1] / 4) + originY);
                    position = vec2(x, y);
                }
                else {
                    // Fallback to origin if no position data
                    position = vec2(0, 0);
                }
                Globals.entitiesData.push({ className, id, position });
            }
        }
    }
    // Create background tile layer (no collisions, renders behind)
    const backgroundTileLayer = new l.TileLayer(vec2(0, 0), vec2(mapWidth, mapHeight), new l.TileInfo(vec2(0), vec2(32), tilesheets.BACKGROUND));
    backgroundTileLayer.renderOrder = 0;
    // Create main tiles layer (with collisions)
    const tilesTileLayer = new l.TileLayer(vec2(0, 0), vec2(mapWidth, mapHeight), new l.TileInfo(vec2(0), vec2(32)));
    tilesTileLayer.renderOrder = 1;
    // Load background tiles (no collisions)
    if (backgroundLayerInstance) {
        const backgroundTilesetWidth = tilesetWidth; // From LDtk data
        const backgroundTilesetHeight = tilesetHeight;
        for (const tile of backgroundLayerInstance.gridTiles) {
            const px = tile.px;
            const x = px[0] / tilesize;
            const y = mapHeight - 1 - (px[1] / tilesize); // Invert Y axis
            const src = tile.src;
            const tileX = src[0] / tilesize;
            const tileY = src[1] / tilesize;
            const tileIndex = tileX + tileY * (backgroundTilesetWidth / tilesize);
            const direction = 0;
            const mirror = false;
            const color = new l.Color(1, 1, 1, 1);
            const data = new l.TileLayerData(tileIndex, direction, mirror, color);
            const pos = vec2(x, y);
            backgroundTileLayer.setData(pos, data);
            // No collision for background
        }
    }
    // Load tiles layer (with collisions)
    if (tilesLayerInstance) {
        for (const tile of tilesLayerInstance.gridTiles) {
            const px = tile.px;
            const x = px[0] / tilesize;
            const y = mapHeight - 1 - (px[1] / tilesize); // Invert Y axis
            const src = tile.src;
            const tileX = src[0] / tilesize;
            const tileY = src[1] / tilesize;
            const tileIndex = tileX + tileY * (tilesetWidth / tilesize);
            const direction = 0;
            const mirror = false;
            const color = new l.Color(1, 1, 1, 1);
            const data = new l.TileLayerData(tileIndex, direction, mirror, color);
            const pos = vec2(x, y);
            tilesTileLayer.setData(pos, data);
            collisionLayer.setCollisionData(pos, 1);
        }
    }
    // Redraw both layers
    backgroundTileLayer.redraw();
    tilesTileLayer.redraw();
    // Instantiate entities from parsed data if level data is provided
    if (rexLevel) {
        console.log(`Instantiating ${Globals.entitiesData.length} entities from LDtk`);
        // Map to store RemoteDoor instances by ID
        const remoteDoors = new Map();
        for (const entityData of Globals.entitiesData) {
            const { className, id, position } = entityData;
            // Adjust position for pivot point difference: LDtk uses center, LittleJS uses top-left
            // Subtract half the entity size to convert from center to top-left origin
            let adjustedPosition = position.copy();
            switch (className) {
                case 'Platform':
                case 'SmallPlatform':
                case 'Door':
                case 'RemoteDoor':
                case 'LockedDoor':
                case 'Checkpoint':
                case 'Goal':
                    adjustedPosition = adjustedPosition.add(vec2(0.5, 0.5));
                    break;
                case 'Trap':
                case 'ElectricityBarrier':
                    // Trap size is dynamic, but default to 5 units width, assume 1 unit height
                    adjustedPosition = adjustedPosition.add(vec2(0.5, 0.5));
                    break;
                case 'ShootingEnemy':
                    adjustedPosition = adjustedPosition.add(vec2(0.5, 0.5));
                    break;
                case 'Lever':
                case 'PressurePlate':
                    adjustedPosition = adjustedPosition.add(vec2(0.5, 0.5));
                    break;
                default:
                    console.warn(`Unknown entity className: ${className}`);
                    break;
            }
            console.log(`Instantiating ${className}${id ? '_' + id : ''} at ${adjustedPosition.x}, ${adjustedPosition.y}`);
            let entity;
            switch (className) {
                case 'Platform':
                    entity = new Platform(adjustedPosition);
                    break;
                case 'SmallPlatform':
                    entity = new SmallPlatform(adjustedPosition);
                    break;
                case 'Door':
                    entity = new Door(adjustedPosition);
                    break;
                case 'RemoteDoor':
                    entity = new RemoteDoor(adjustedPosition);
                    if (id) {
                        remoteDoors.set(id, entity);
                    }
                    break;
                case 'Lever':
                    if (id && remoteDoors.has(id)) {
                        entity = new Lever(adjustedPosition, remoteDoors.get(id));
                    }
                    else {
                        console.warn(`Skipping Lever instantiation: no matching RemoteDoor with id ${id}`);
                    }
                    break;
                case 'PressurePlate':
                    if (id && remoteDoors.has(id)) {
                        entity = new PressurePlate(adjustedPosition, remoteDoors.get(id));
                    }
                    else {
                        console.warn(`Skipping PressurePlate instantiation: no matching RemoteDoor with id ${id}`);
                    }
                    break;
                case 'Trap':
                    entity = new Trap(adjustedPosition, 5); // Default size
                    break;
                case 'ElectricityBarrier':
                    entity = new ElectricityBarrier(adjustedPosition, 5); // Default size
                    break;
                case 'Checkpoint':
                    entity = new Checkpoint(adjustedPosition);
                    break;
                case 'Goal':
                    entity = new Goal(adjustedPosition);
                    break;
                case 'ShootingEnemy':
                    entity = new ShootingEnemy(adjustedPosition);
                    break;
                case 'Key':
                    entity = new Key(adjustedPosition);
                    break;
                case 'LockedDoor':
                    entity = new LockedDoor(adjustedPosition);
                    break;
                default:
                    console.warn(`Unknown entity className: ${className}`);
                    break;
            }
            if (entity) {
                entity.renderOrder = 2;
            }
        }
    }
    // Add test platforms and entities only if no level data provided
    if (!rexLevel) {
        // Add a platform
        for (let x = 5; x <= 10; x++) {
            const plat = new Platform(vec2(x + 0.5, 3 + 0.5));
            platforms.push(plat);
            plat.renderOrder = 2;
        }
        tileLayer.redraw();
        // Add small platforms for Chip
        for (let x = 5; x <= 10; x++) {
            const small_plat = new SmallPlatform(vec2(15 + x * 0.25, 1.5));
            smallPlatforms.push(small_plat);
            small_plat.renderOrder = 2;
        }
        // Add a checkpoint
        const checkpoint = new Checkpoint(vec2(10, 2));
        checkpoint.renderOrder = 2;
        // Add a door to test actionables
        const door = new Door(vec2(20, 2));
        door.renderOrder = 2;
        // Add a remote door to test levers
        let remote_door = new RemoteDoor(vec2(24, 2));
        remote_door.renderOrder = 2;
        const lever = new Lever(vec2(28, 2), remote_door);
        lever.renderOrder = 2;
        // Add a trap
        const trap = new Trap(vec2(32, 2), 5);
        trap.renderOrder = 2;
        // Add a goal
        const goal = new Goal(vec2(3, 2));
        goal.renderOrder = 2;
    }
    // Spawn Rex and Chip
    let rexSpawnPos = vec2(mapWidth / 2, mapHeight / 2); // default
    if (rexLevel) {
        // Use Rex position from LDtk if available
        for (const entityData of Globals.entitiesData) {
            if (entityData.className === 'Rex') {
                rexSpawnPos = entityData.position.add(vec2(0.5, 0.5)); // adjust for pivot
                break;
            }
        }
    }
    rex = new Rex(rexSpawnPos);
    rex.renderOrder = 2;
    Globals.rex = rex;
    chip = new Chip(vec2(15, mapHeight / 2));
    chip.renderOrder = 2;
    Globals.chip = chip;
    playerObject = rex;
    Globals.player = rex;
    // Put Chip on Rex's back instantly
    rex.chipOnBack = true;
    chip.visible = false;
    // Set initial checkpoint
    Globals.lastCheckpoint = rex.pos.copy();
    // Setup camera
    camera.init(rex.pos.copy(), rex);
}
/**
 * Switches between Rex and Chip
 */
function switchPlayer() {
    if (!rex || !chip) {
        return;
    }
    if (player == "rex") {
        // If Chip is on back, drop it first
        if (rex.chipOnBack) {
            chip.pos = rex.pos.copy();
            chip.visible = true;
            rex.chipOnBack = false;
        }
        rex.controlling = false;
        chip.controlling = true;
        player = "chip";
        playerObject = chip;
        Globals.player = chip;
        camera.setTarget(chip, true);
    }
    else {
        rex.controlling = true;
        chip.controlling = false;
        player = "rex";
        playerObject = rex;
        Globals.player = rex;
        camera.setTarget(rex, false);
    }
}
function update() {
    // Check if game is in levelStart state - if so, don't update game logic
    if (Globals.gameState === 'levelStart') {
        return;
    }
    // Game logic
    if (l.keyWasReleased('KeyX')) {
        console.log('SWITCH');
        switchPlayer();
    }
    // Pickup/drop Chip
    if (l.keyWasReleased('KeyC')) {
        if (rex && chip) {
            if (rex.chipOnBack) {
                // Drop Chip
                chip.pos = rex.pos.copy();
                chip.visible = true;
                rex.chipOnBack = false;
                // We transfer the velocity of Rex so we can throw Chip if we drop him while jumping
                // I think it's a funny easter-egg for players who want to cheat the mechanics
                chip.velocity.x = rex.velocity.x;
                chip.velocity.y = rex.velocity.y;
            }
            else {
                // Pickup Chip if close
                const distance = rex.pos.distance(chip.pos);
                if (distance < 2) {
                    chip.visible = false;
                    rex.chipOnBack = true;
                    if (player == "chip") {
                        switchPlayer();
                    }
                }
            }
        }
    }
    // Platform collision logic is now handled in the Platform classes themselves
    // via the collideWithObject method, which checks for the current player
    // Check for death and respawn
    if ((rex && rex.health <= 0) || (chip && chip.health <= 0)) {
        respawn();
    }
}
function updatePost() {
    // Post update (camera, etc.)
}
function render() {
    // Custom render
}
function renderPost() {
    // UI render
    let pickupText = '';
    if (rex?.chipOnBack) {
        pickupText = 'Press C to drop Chip';
    }
    else if (rex && chip) {
        const distance = rex.pos.distance(chip.pos);
        if (distance < 1) {
            pickupText = 'Press C to take Chip on your back';
        }
    }
    camera.update();
    hud.render(player, rex?.health || 0, chip?.battery || 0, pickupText);
}
function isGoalReached() {
    // Check if any Goal entity has been reached
    const goals = l.engineObjects.filter(obj => obj instanceof Goal);
    const reached = goals.some(goal => goal.reached);
    if (reached && !Globals.levelCompleted) {
        Globals.levelCompleted = true;
        Globals.levelCompletionTime = Date.now() - Globals.levelStartTime;
    }
    return reached;
}
export { init, update, updatePost, render, renderPost, isGoalReached };
